import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { TagDto } from 'src/core/models/conversation/tag/tag.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { TagSelectionConfigurationModel } from '../models/tag-selection-configuration.model';

@Component({
    selector: 'ca-tag-selection-panel',
    templateUrl: './tag-selection-panel.component.html',
    styleUrls: ['./tag-selection-panel.component.scss'],
    standalone: false
})
export class TagSelectionPanelComponent extends FilterPanelEditorComponent implements OnInit {
  actualConfig: TagSelectionConfigurationModel;

  _value: TagDto[];
  tagSelectorOptions: any;

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  tagSelector: SelectorComponent;

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as TagSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private localizationService: LocalizationService,
    private operators: Operators,
    protected fb: FormBuilder
  ) {
    super(fb);

    this.tagSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectTag'),
      multiple: true,
      url: 'api/app/tag',
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
    };

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void { }

  reload(): void { }

  reset(): void { }
  
  autoSelectFirstItem(): void {}

  init() {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.tagSelector.refresh();
    }
  }
}
